module.exports = __webpack_public_path__ + "img/5.be1aef97.png";